$(function () {
  'use strict'

  $(document).on('ready PhoneChip::Process', function () {
    if (Modernizr.touch) {
      // На мобилке пока не сделаем ничего
    } else {
      // В остальных случаях покажем номер телефона, если он скрыт
      $('.profile-header__phone').show();
    }
    var $root = $('.phone-chip')

    if ($root.length > 0) {
      var $show = $root.find('.phone-chip__show-more')
      $show.off('click')

      var handleClick = function (event) {
        event.preventDefault()

        $show = $(this)
        $root = $show.closest($root)
        var $hideable = $root.find('.phone-chip__hideable')

        $show.off('click')

        var firm_user_id = $root.data('firm_user_id')
        var firm_phone = $root.data('firm_phone')
        var firm_forwarding = $root.data('firm_forwarding');

        if (typeof firm_phone !== 'string') {
          firm_phone = firm_phone + ''
        }

        $.ajax({
          type: (Modernizr.touch) ? 'GET' : 'POST',
          url: '/profile/phone_show/',
          data: {firm_user_id: firm_user_id}
        })
          .success(function () {
            var firm_phones = firm_phone.split(',')
            var classname = ''

            if (firm_phones.length > 1) classname = _($hideable[0].className.replace($hideable.selector, '')).trim() || 'phone-chip__phone'

            $hideable.remove()

            $.each(firm_phones, function (i, rawPhone) {
              var phone
              if (Modernizr.touch) {
                var tel = rawPhone.replace(/( |-|\(|\))/g, '')
                if (tel.length == 11 && _.chars(tel)[0] == '8') {
                  tel.replace(/^8/, '+7')
                }

                if (firm_forwarding)
                  tel += ","+firm_forwarding
                phone = '<a onclick="$.post(\'/profile/phone_show/\', {firm_user_id: '+firm_user_id+'})" style="padding: 10px !important; color: #FFFFFF;" class="profile__header__button button_trompeloeil-dark-red" href="tel:' + tel + '"><i class="phone-chip__icon icon-smartphone" style="color: #FFFFFF;"></i> Позвонить</a>'
              }
              else {
                phone = '<span class="' + classname + ' vcard"><span class="tel">' + rawPhone + '</span></span> '
              }
              $root.append(phone)
              if (firm_forwarding && !Modernizr.touch) {
                $root.append('<span class="forwarding"><span class="additional">добавочный</span>&nbsp;<span class="number">'+firm_forwarding+'</span></span>');
              }
            })

            $show.remove()
          })
          .fail(function () {
            $show.on('click', handleClick)
          })
      }

      $show.on('click', handleClick)

      $(document).trigger('PhoneChip::Processed', [$show])
    }
  })
})
